// Be careful, itineraries are calculated using the snippet params
//  and not the metarouter endpoint
export const MULTIROUTERS_ENDPOINT = 'https://routing.getwemap.com/v4';
export const MULTIROUTERS_ENDPOINT_DEV = 'https://routing.maaap.it/v4';
export const LIVEMAP_ENDPOINT = 'https://livemap.getwemap.com';
